import axios from "axios";
import {loginUserApi} from '../_constants/api.constant'
import {getSelfToken} from '../../_helpers/auth/secureToken'
export async function getUser(dataId){
    console.log('From-getUser',loginUserApi.VIEW+'?id='+dataId,)
    const response=await axios.get(
        loginUserApi.VIEW+'?id='+dataId,
        {
            headers:{
                Authorization: 'Token '+getSelfToken(),
            },
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
     

        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}